import { Color } from '@superdispatch/ui';
import { createSvgIcon } from 'shared/icons/IconUtils';

export const WarningTriangleIcon = createSvgIcon(
  'WarningTriangleIcon',
  <>
    <g clipPath="url(#clip0_3958_64121)">
      <path
        d="M3.4165 17.4971H16.5835C17.93 17.4971 18.7693 16.0242 18.0961 14.8512L11.5126 3.37683C10.8394 2.20382 9.16069 2.20382 8.48747 3.37683L1.90395 14.8512C1.23073 16.0242 2.07007 17.4971 3.4165 17.4971ZM10 11.3233C9.51915 11.3233 9.12572 10.9264 9.12572 10.4414V8.67743C9.12572 8.19235 9.51915 7.79547 10 7.79547C10.4809 7.79547 10.8743 8.19235 10.8743 8.67743V10.4414C10.8743 10.9264 10.4809 11.3233 10 11.3233ZM10.8743 14.8512H9.12572V13.0873H10.8743V14.8512Z"
        fill={Color.Yellow300}
      />
    </g>
    <defs>
      <clipPath id="clip0_3958_64121">
        <rect width="20" height="20" fill={Color.White} />
      </clipPath>
    </defs>
  </>,
  { viewBox: '0 0 20 20' },
);
